const headerWrapper = document.querySelector('.header-wrapper');
const header = headerWrapper?.querySelector('.header') || document.querySelector('.header');
const stepBar = document.querySelector('.donation-page__steps');

let animationFrameId = null;
let lastHeaderHeight = '';
let lastStepBarHeight = '';

function updateHeightsNow() {
    if (headerWrapper && header) {
        const nextHeaderHeight = `${Math.ceil(header.getBoundingClientRect().height)}px`;
        if (nextHeaderHeight !== lastHeaderHeight) {
            document.body.style.setProperty('--header-height', nextHeaderHeight);
            lastHeaderHeight = nextHeaderHeight;
        }
    }

    if (stepBar) {
        const nextStepBarHeight = `${stepBar.offsetHeight}px`;
        if (nextStepBarHeight !== lastStepBarHeight) {
            document.body.style.setProperty('--step-bar-height', nextStepBarHeight);
            lastStepBarHeight = nextStepBarHeight;
        }
    }
}

function scheduleUpdateHeights() {
    if (animationFrameId !== null) return;

    animationFrameId = window.requestAnimationFrame(() => {
        animationFrameId = null;
        updateHeightsNow();
    });
}

function onResizeEvent() {
    scheduleUpdateHeights();
}

if (headerWrapper || stepBar) {
    scheduleUpdateHeights();

    window.addEventListener('resize', onResizeEvent);
    window.addEventListener('orientationchange', onResizeEvent);
    window.addEventListener('load', onResizeEvent);

    if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(() => {
            scheduleUpdateHeights();
        });

        if (header) {
            resizeObserver.observe(header);
        }

        if (stepBar) {
            resizeObserver.observe(stepBar);
        }
    }
}
